import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";
import '@/Pages/PolitikaKonfidencialnosti/scss/index.scss';

class PolitikaKonfidencialnosti extends React.Component {

    render() {
        const {mobileApp = false} = this.props

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`breadcrumbs`}>
                        <div className="container">
                            <Breadcrumbs
                                maxItems={2}
                                itemsAfterCollapse={2}
                            >
                                <Link className="breadcrumbs__link" href={`/`}>
                                    Главная
                                </Link>
                                <p className="breadcrumbs__text">
                                    Политика конфиденциальности
                                </p>
                            </Breadcrumbs>
                        </div>
                    </div>
                )}
                <div className={`container`}>
                    <h1 className={`h1`}>Политика конфиденциальности</h1>
                    <div className={`politika-konfidencialnosti`}>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__item`}>
                                Настоящая Политика конфиденциальности персональных данных
                                (далее&nbsp;&mdash; Политика конфиденциальности) действует в&nbsp;отношении всей
                                информации, размещенной на&nbsp;сайте в&nbsp;сети Интернет по&nbsp;адресу:
                                platina-jewelry.ru (далее&nbsp;&mdash; Сайт), которую посетители, другие
                                пользователи могут получить о&nbsp;Пользователе во&nbsp;время использования
                                Сайта, его сервисов, программ и&nbsp;продуктов.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                Использование сервисов Сайта означает безоговорочное согласие Пользователя
                                с&nbsp;настоящей Политикой и&nbsp;указанными в&nbsp;ней условиями обработки его
                                персональной информации; в&nbsp;случае несогласия с&nbsp;этими условиями
                                Пользователь должен воздержаться от&nbsp;использования сервисов.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                1. Общие положения
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                1.1. В&nbsp;рамках настоящей Политики под персональной информацией Пользователя
                                понимаются:
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                1.1.1. персональная информация, которую Пользователь предоставляет о&nbsp;себе
                                самостоятельно при регистрации (создании учетной записи) или в&nbsp;процессе
                                использования Сервисов, включая персональные данные Пользователя. Обязательная
                                для предоставления Сервисов информация помечена специальным образом. Иная
                                информация предоставляется Пользователем на&nbsp;его усмотрение.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                1.1.2. данные, которые автоматически передаются сервисам Сайта в&nbsp;процессе
                                их&nbsp;использования с&nbsp;помощью установленного на&nbsp;устройстве Пользователя
                                программного обеспечения, в&nbsp;том числе IP-адрес, данные файлов cookie (небольшие
                                текстовые файлы, размещаемые на&nbsp;устройстве Пользователя для корректной работы
                                сайта), информация о&nbsp;браузере Пользователя (или иной программе, с&nbsp;помощью
                                которой осуществляется доступ к&nbsp;сервисам), технические характеристики оборудования
                                и&nbsp;программного обеспечения, используемых Пользователем, дата и&nbsp;время доступа
                                к&nbsp;сервисам, адреса запрашиваемых страниц и&nbsp;иная подобная информация.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                1.1.3. иная информация о&nbsp;Пользователе, обработка которой предусмотрена
                                Пользовательским соглашением.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                1.2. Настоящая Политика конфиденциальности применяется только к&nbsp;Сайту
                                platina-jewelry.ru. Сайт platina-jewelry.ru не&nbsp;контролирует
                                и&nbsp;не&nbsp;несет ответственности за&nbsp;сайты третьих лиц, на&nbsp;которые
                                Пользователь может перейти по&nbsp;ссылкам, доступным на&nbsp;Сайте
                                platina-jewelry.ru.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                2. Цели обработки персональной информации пользователей
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.1. Сайт собирает и&nbsp;хранит только ту&nbsp;персональную информацию, которая
                                необходима для предоставления сервисов или исполнения соглашений
                                и&nbsp;договоров с&nbsp;Пользователем, за&nbsp;исключением случаев, когда
                                законодательством предусмотрено обязательное хранение персональной информации
                                в&nbsp;течение определенного законом срока.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2. Персональную информацию Пользователя Сайт обрабатывает в&nbsp;следующих
                                целях:
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.1. идентификации Пользователя, зарегистрированного на&nbsp;Сайте, для оформления
                                заказа&nbsp;и (или) заключения Договора купли-продажи товара дистанционным способом;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.2. предоставления Пользователю доступа к&nbsp;персонализированным ресурсам
                                Сайта;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.3. установления с&nbsp;Пользователем обратной связи, включая направление
                                уведомлений, запросов, касающихся использования Сайта, оказания услуг, обработку
                                запросов и&nbsp;заявок от&nbsp;Пользователя;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.4. определения места нахождения Пользователя для обеспечения безопасности,
                                предотвращения мошенничества;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.5. подтверждения достоверности и&nbsp;полноты персональных данных,
                                предоставленных Пользователем;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.6. создания учетной записи для совершения покупок, если Пользователь дал
                                согласие на&nbsp;создание учетной записи;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.7. уведомления Пользователя Сайта о&nbsp;статусе заказа;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.8. предоставления Пользователю эффективной клиентской и&nbsp;технической
                                поддержки при возникновении проблем, связанных с&nbsp;использованием Сайта;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.9. осуществления рекламной деятельности с&nbsp;согласия Пользователя;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                2.2.10. предоставления Пользователю с&nbsp;его согласия, обновлений продукции,
                                специальных предложений, информации о&nbsp;ценах, новостной рассылки и&nbsp;иных
                                сведений от&nbsp;имени Сайта.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                3. Условия обработки персональной информации пользователей
                                и&nbsp;ее&nbsp;передачи третьим лицам
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.1. Сайт хранит персональную информацию Пользователей в&nbsp;соответствии
                                с&nbsp;внутренними регламентами конкретных сервисов.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.2. В&nbsp;отношении персональной информации Пользователя сохраняется
                                ее&nbsp;конфиденциальность, кроме случаев добровольного предоставления
                                Пользователем информации о&nbsp;себе для общего доступа неограниченному кругу
                                лиц. При использовании отдельных сервисов Пользователь соглашается с&nbsp;тем,
                                что определенная часть его персональной информации становится общедоступной.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.3. Сайт вправе передать персональную информацию Пользователя третьим лицам
                                в&nbsp;следующих случаях:
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.3.1. пользователь выразил
                                <a href={`/storage/docs/soglasie-na-obrabotku-personal'nyh-dannyh-na-rasprostranenie.pdf`}
                                   className={`link link__bold link__pdf`}
                                   target={`_blank`}>
                                    &nbsp;согласие на&nbsp;такие действия;
                                </a>

                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.3.2. передача необходима для использования Пользователем определенного сервиса
                                либо для исполнения определенного соглашения или договора с&nbsp;Пользователем;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.3.3. передача предусмотрена российским или иным применимым законодательством
                                в&nbsp;рамках установленной законодательством процедуры;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.3.4. в&nbsp;случае продажи Сайта к&nbsp;приобретателю переходят все обязательства
                                по&nbsp;соблюдению условий настоящей Политики применительно к&nbsp;полученной
                                им&nbsp;персональной информации.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.4.
                                <a href={`/storage/docs/soglasie-na-obrabotku-personal'nyh-dannyh.pdf`}
                                   className={`link link__bold link__pdf`}
                                   target={`_blank`}>
                                    &nbsp;Обработка персональных данных&nbsp;
                                </a>
                                Пользователя осуществляется без ограничения
                                срока любым законным способом, в&nbsp;том числе в&nbsp;информационных системах
                                персональных данных с&nbsp;использованием средств автоматизации или без
                                использования таких средств. Обработка персональных данных Пользователей
                                осуществляется в&nbsp;соответствии с&nbsp;Федеральным
                                <a href="http://www.consultant.ru/document/cons_doc_LAW_61801/"
                                   className={`link link__bold link__pdf`}
                                   target={`_blank`}>
                                    &nbsp;законом&nbsp;
                                </a>
                                от&nbsp;27.07.2006 &#8470;&nbsp;152-ФЗ &laquo;О&nbsp;персональных данных&raquo;.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.5. При утрате или разглашении персональных данных Администрация Сайта
                                информирует Пользователя об&nbsp;утрате или разглашении персональных данных.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.6. Администрация Сайта принимает необходимые организационные
                                и&nbsp;технические меры для защиты персональной информации Пользователя
                                от&nbsp;неправомерного или случайного доступа, уничтожения, изменения,
                                блокирования, копирования, распространения, а&nbsp;также от&nbsp;иных
                                неправомерных действий третьих лиц.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                3.7. Администрация Сайта совместно с&nbsp;Пользователем принимает все
                                необходимые меры по&nbsp;предотвращению убытков или иных отрицательных
                                последствий, вызванных утратой или разглашением персональных данных
                                Пользователя.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                4. Обязательства сторон
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.1. Пользователь обязан:
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.1.1. предоставить информацию о&nbsp;персональных данных, необходимую для
                                пользования Сайтом;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.1.2. обновлять, дополнять предоставленную информацию о&nbsp;персональных данных
                                в&nbsp;случае изменения данной информации.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.2. Администрация Сайта обязана:
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.2.1. использовать полученную информацию исключительно для целей, указанных
                                в&nbsp;настоящей Политике конфиденциальности;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.2.2. обеспечить хранение конфиденциальной информации в&nbsp;тайне,
                                не&nbsp;разглашать без предварительного письменного разрешения Пользователя,
                                а&nbsp;также не&nbsp;осуществлять продажу, обмен, опубликование либо разглашение
                                иными возможными способами переданных персональных данных Пользователя,
                                за&nbsp;исключением предусмотренных настоящей Политикой конфиденциальности;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.2.3. принимать меры предосторожности для защиты конфиденциальности персональных
                                данных Пользователя согласно порядку, обычно используемому для защиты такого рода
                                информации в&nbsp;существующем деловом обороте;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                4.2.4. осуществить блокирование персональных данных, относящихся
                                к&nbsp;соответствующему Пользователю, с&nbsp;момента обращения или запроса
                                Пользователя или его законного представителя либо уполномоченного органа
                                по&nbsp;защите прав субъектов персональных данных на&nbsp;период проверки
                                в&nbsp;случае выявления недостоверных персональных данных или неправомерных
                                действий.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                5. Ответственность сторон
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                5.1. Администрация Сайта, не&nbsp;исполнившая свои обязательства, несет
                                ответственность за&nbsp;убытки, понесенные Пользователем в&nbsp;связи
                                с&nbsp;неправомерным использованием персональных данных, в&nbsp;соответствии
                                с&nbsp;законодательством Российской Федерации.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                5.2. В&nbsp;случае утраты или разглашения конфиденциальной информации
                                Администрация Сайта не&nbsp;несет ответственности, если данная конфиденциальная
                                информация:
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                5.2.1. стала публичным достоянием до&nbsp;ее&nbsp;утраты или разглашения;
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                5.2.2. была получена от&nbsp;третьей стороны до&nbsp;момента ее&nbsp;получения
                                Администрацией Сайта.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                5.2.3. была разглашена с&nbsp;согласия Пользователя.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                6. Разрешение споров
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                6.1. До&nbsp;обращения в&nbsp;суд с&nbsp;иском по&nbsp;спорам, возникающим
                                из&nbsp;отношений между Пользователем Сайта и&nbsp;Администрацией Сайта,
                                обязательным является предъявление претензии (письменного предложения
                                о&nbsp;добровольном урегулировании спора).
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                6.2. Получатель претензии в&nbsp;течение&nbsp;30 (Тридцати) календарных дней
                                со&nbsp;дня получения претензии письменно уведомляет заявителя претензии
                                о&nbsp;результатах рассмотрения претензии.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                6.3. При не&nbsp;достижении соглашения спор будет передан на&nbsp;рассмотрение
                                в&nbsp;суд в&nbsp;соответствии с&nbsp;действующим законодательством Российской
                                Федерации. При этом Пользователь выражает свое полное и&nbsp;безоговорочное согласие
                                с&nbsp;тем, что все споры, возникающие между Администрацией сайта
                                и&nbsp;Пользователем, который является юридическим лицом или индивидуальным
                                предпринимателем, подлежат рассмотрению в&nbsp;Арбитражном суде Костромской области.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                6.4. К&nbsp;настоящей Политике конфиденциальности и&nbsp;отношениям между
                                Пользователем и&nbsp;Администрацией Сайта применяется действующее законодательство
                                Российской Федерации.
                            </p>
                        </div>
                        <div className={`politika-konfidencialnosti__section`}>
                            <p className={`politika-konfidencialnosti__title`}>
                                7. Дополнительные условия
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                7.1. Администрация Сайта вправе вносить изменения в&nbsp;настоящую Политику
                                конфиденциальности без согласия Пользователя.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                7.2. Новая Политика конфиденциальности вступает в&nbsp;силу с&nbsp;момента
                                ее&nbsp;размещения на&nbsp;Сайте, если иное не&nbsp;предусмотрено новой
                                редакцией Политики конфиденциальности.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                7.3. Все предложения или вопросы по&nbsp;настоящей Политике конфиденциальности
                                следует сообщать на&nbsp;электронную почту help@platina-jewelry.ru.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                7.4. Действующая Политика конфиденциальности размещена на&nbsp;странице
                                по&nbsp;адресу: platina-jewelry.ru.
                            </p>
                            <p className={`politika-konfidencialnosti__item`}>
                                7.5. Настоящая Политика конфиденциальности является неотъемлемой частью
                                Соглашения об&nbsp;использовании Сайта, размещенного на&nbsp;странице
                                по&nbsp;адресу: platina-jewelry.ru.
                            </p>
                        </div>
                    </div>
                    <a href={`/storage/docs/soglasie-na-obrabotku-personal'nyh-dannyh.pdf`}
                       className={`link link__bold link__pdf`}
                       target={`_blank`}>
                        Согласие на обработку персональных данных
                    </a>
                    <p>&nbsp;</p>
                    <a href={`/storage/docs/soglasie-na-obrabotku-personal'nyh-dannyh-na-rasprostranenie.pdf`}
                       className={`link link__bold link__pdf`}
                       target={`_blank`}>
                        Согласие на обработку персональных данных, разрешенных субъектом персональных данных для
                        распространения
                    </a>
                </div>
            </section>
        </BaseLayout>
    }
}

export default useWithStore(PolitikaKonfidencialnosti);


